import { Users } from "lucide-react";
import Disclaimer from "@/components/shared/Disclaimer";
import Footer from "@/components/shared/Footer";

const TermsPage = () => (
  <main className="min-h-screen bg-slate-50"><Disclaimer />
    <div className="container-shell py-12 max-w-3xl prose prose-slate">
      <h1>Terms of Service</h1>
      <p>Trialeze provides procedural analytics tools for legal professionals. By using this service, you agree to these terms.</p>
      <h2>No Legal Advice</h2>
      <p>Trialeze does not provide legal advice. All outputs are informational analytics only and should not be interpreted as legal counsel or outcome predictions.</p>
      <h2>Limitation of Liability</h2>
      <p>Trialeze is not liable for any decisions made based on the analytics provided. Users must exercise independent professional judgment.</p>
    </div>
    <Footer />
  </main>
);


export default TermsPage;
